import { createFileRoute } from '@tanstack/react-router'
import { OrganizationSettingsPageClient } from '#/components/settings/OrganizationSettingsPageClient'

export const Route = createFileRoute(
  '/_authenticated/$slug/settings/organization',
)({
  component: OrganizationSettingsPageClient,
})
